module.exports = __webpack_public_path__ + "img/interaction_none.47e999f3.svg";